/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */
import Config from 'config'
import HttpProvider from '@/services/HttpProvider'
import Graphql from '@/services/Graphql'
import { mapCheckoutAddress, getSuffixGuest, graphqlManageError } from '@/helpers'
import { mapCheckoutAddressGraph } from '@/helpers/utils'
import GQSetEmailForGuest from './graphql/setEmailForGuest'
import GQSetShippingAddresOnCart from './graphql/setShippingAddressesOnCart'
import GQSetBillingAddressOnCart from './graphql/setBillingAddressOnCart'
import GQSetShippingMethodsOnCart from './graphql/setShippingMethodsOnCart'
import GQGetCart from './graphql/getCart'
import find from 'lodash/find'

let promiseCountriesOn = false

function getCartID (ctx) {
  return ctx.rootGetters['user/isLogged'] ? ctx.rootState.cart.cartIdMask : ctx.rootState.cart.cartId
}

export default {
  getShippingMethods (ctx, { countryId = Config.Theme.default.country }) {
    const cartId = ctx.rootState.cart.cartId
    /* if (!(token && cartId)) {
      throw new Error('credenzial necessary')
    } */
    return HttpProvider.get(Config.API.cart[`shippingMethods${getSuffixGuest(ctx.rootGetters)}`]
      .replace('{{storeViewCode}}', ctx.rootState.ui.storeViewCode)
      .replace('{{cartId}}', cartId))
      .then(res => {
        ctx.commit('setShippingMethods', res.data)
        return res.data
      })
      .catch(error => {
        console.error('shipping', error)
        // ctx.dispatch('user/logout', null, { root: true })
        throw new Error(error)
      })
  },
  getPaymentMethods (ctx) {
    return HttpProvider.get(Config.API.cart[`paymentMethods${getSuffixGuest(ctx.rootGetters)}`]
      .replace('{{storeViewCode}}', ctx.rootState.ui.storeViewCode)
      .replace('{{cartId}}', ctx.rootState.cart.cartId))
      .then(res => {
        ctx.commit('setPaymentMethods', res.data)
        return res.data
      })
      .catch(error => {
        ctx.dispatch('user/logout', null, { root: true })
        throw new Error(error)
      })
  },
  loadCountries (ctx) {
    if (global.loadCountryFlag && global.loadCountryFlag !== ctx.rootState.ui.storeViewCode) {
      global.loadCountryFlag = ctx.rootState.ui.storeViewCode
      ctx.commit('setCountries', [])
    }
    if (ctx.state.countries.length > 0) {
      return Promise.resolve(ctx.state.countries)
    }
    if (promiseCountriesOn) {
      return promiseCountriesOn
    }

    promiseCountriesOn = HttpProvider.get(Config.API.common.countries
      .replace('{{storeViewCode}}', ctx.rootState.ui.storeViewCode)
    ).then(response => {
      promiseCountriesOn = false
      if (response.status === 200) {
        ctx.commit('setCountries', response.data)
        return ctx.state.countries
      }
      return []
    })
    return promiseCountriesOn
  },
  tempOrder (ctx, { $store }) {
    return ctx.dispatch('loadCountries')
      .then(() => {
        const order = {
          user_id: $store.state.user.current ? '' + $store.state.user.current.id : '',
          cart_id: $store.state.cart.cartId,
          addressInformation: {
            shippingAddress: mapCheckoutAddress($store.state.checkout.shippingAddress, false, $store),
            billingAddress: mapCheckoutAddress($store.state.checkout.billingAddress, true, $store),
            shipping_method_code: $store.state.checkout.shippingAddress.shippingMethod,
            shipping_carrier_code: $store.state.checkout.shippingAddress.shippingMethod,
            payment_method_code: $store.state.checkout.paymentMethod.current,
            payment_method_additional: $store.state.checkout.paymentMethod.paymentMethodAdditional
          },
          products: $store.state.cart.pullItems
        }
        ctx.commit('setTempOrder', order)
        return ctx.state.tmpOrder
      })
  },
  terms (ctx) {
    return Graphql.genericCall(
      {},
      ctx.rootState.user.token,
      ctx.rootState.ui.storeViewCode,
      null,
      {}, // variable
      false, // cache
      {
        query: require('./graphql/terms').default
      }
    ).then(res => {
      if (graphqlManageError(res)) {
        // eslint-disable-next-line
        throw { errors: [{ message: graphqlManageError(res) }] }
      }
      const terms = res.data.checkoutAgreements ? res.data.checkoutAgreements : []
      ctx.commit('terms', terms)
      return terms
    })
  },
  async setEmailForGuest (ctx, email) {
    const cartId = getCartID(ctx)
    if (cartId) {
      return Graphql.genericCall(
        {},
        ctx.rootState.user.token,
        ctx.rootState.ui.storeViewCode,
        null,
        {
          input: {
            cart_id: cartId,
            email
          }
        }, // variable
        false, // cache
        {
          query: GQSetEmailForGuest
        }
      ).then(res => {
        if (graphqlManageError(res)) {
          // eslint-disable-next-line
          throw { errors: [{ message: graphqlManageError(res) }] }
        }
        const cart = res.data.setEmailForGuest ? res.data.setEmailForGuest.cart : null
        cart && ctx.commit('updCart', cart)
        return res
      })
    } else {
      // eslint-disable-next-line
      throw { errors: [{ message: 'cart id required' }] }
    }
  },
  async setAddress (ctx, { address, type = 'Shipping' }) {
    await ctx.dispatch('loadCountries')
    const cartId = getCartID(ctx)
    if (cartId) {
      let input = {
        cart_id: cartId
      }
      if (type === 'Shipping') {
        input.shipping_addresses = [{ address: mapCheckoutAddressGraph(address, false, ctx.rootState, ctx.rootGetters) }]
      } else {
        input.billing_address = { address: mapCheckoutAddressGraph(address, true, ctx.rootState, ctx.rootGetters) }
      }
      return Graphql.genericCall(
        {},
        ctx.rootState.user.token,
        ctx.rootState.ui.storeViewCode,
        null,
        {
          input
        }, // variable
        false, // cache
        {
          query: type === 'Shipping' ? GQSetShippingAddresOnCart : GQSetBillingAddressOnCart
        }
      ).then(res => {
        if (graphqlManageError(res)) {
          // eslint-disable-next-line
          throw { errors: [{ message: graphqlManageError(res) }] }
        }
        const cart = res.data ? (type === 'Shipping' ? res.data.setShippingAddressesOnCart.cart : res.data.setBillingAddressOnCart.cart) : null
        cart && ctx.commit('updCart', cart)
      })
    } else {
      // eslint-disable-next-line
      throw { errors: [{ message: 'cart id required' }] }
    }
  },
  async setPickupAddress (ctx, boutique) {
    const setAddress = async () => {
      let country = ctx.state.countries.find((c) => c.id === boutique.country_code)
      let postalcode = boutique.postalcode || null
      let region = 0
      let regionToCheck = []
      if (country) {
        if (country.available_regions && country.available_regions.length) {
          await ctx.dispatch('ui/reverseGeocode', { lat: boutique.latitude, lng: boutique.longitude, resultType: 'postal_code', language: country.id }, { root: true })
            .then((res) => {
              if (res.data && res.data.status === 'OK') {
                let geocode = res.data
                for (let i in geocode.results) {
                  geocode.results[i].address_components.forEach(element => {
                    element.types.forEach(type => {
                      if (type === 'postal_code') {
                        postalcode = element.short_name
                      }
                      if (type === 'administrative_area_level_1') {
                        regionToCheck.push(element)
                      }
                      if (type === 'administrative_area_level_2') {
                        regionToCheck.push(element)
                      }
                    })
                  })
                  if (regionToCheck.length && postalcode) {
                    //  exit if variable are setted
                    break
                  }
                }
                for (let i in regionToCheck) {
                  region = find(country.available_regions, function (region) {
                    return regionToCheck[i].short_name === region.code || regionToCheck[i].long_name === region.name
                  })
                  if (region) {
                    break
                  }
                }
                if (!region) {
                  // eslint-disable-next-line
                  throw { message: [{ message: 'No region found from geocode' }] }
                }
              } else {
                // eslint-disable-next-line
                throw { message: [{ message: 'Geocodification failed' }] }
              }
            })
        }
        const formatAddress = {
          city: boutique.city,
          company: '',
          country_code: country.id,
          region: region.code,
          region_id: Number(region.id),
          firstname: boutique.name,
          lastname: boutique.name,
          postcode: postalcode,
          street: boutique.address,
          telephone: boutique.phone,
          save_in_address_book: false
        }
        return formatAddress
      } else {
        // eslint-disable-next-line
        throw { errors: [{ message: 'country-not-available-for-pickup' }] }
      }
    }
    await ctx.dispatch('loadCountries')
    const cartId = getCartID(ctx)
    if (cartId) {
      let input = {
        cart_id: cartId
      }
      input.shipping_addresses = [{ address: await setAddress() }]
      return Graphql.genericCall(
        {},
        ctx.rootState.user.token,
        ctx.rootState.ui.storeViewCode,
        null,
        {
          input
        }, // variable
        false, // cache
        {
          query: GQSetShippingAddresOnCart
        }
      ).then(res => {
        if (graphqlManageError(res)) {
          // eslint-disable-next-line
          throw { errors: [{ message: graphqlManageError(res) }] }
        }
        const cart = res.data ? res.data.setShippingAddressesOnCart.cart : null
        cart && ctx.commit('updCart', cart)
      })
    } else {
      // eslint-disable-next-line
      throw { errors: [{ message: 'cart id required' }] }
    }
  },
  async setShippingMethods (ctx, shippingMethod) {
    const cartId = getCartID(ctx)
    if (cartId) {
      return Graphql.genericCall(
        {},
        ctx.rootState.user.token,
        ctx.rootState.ui.storeViewCode,
        null,
        {
          input: {
            cart_id: cartId,
            shipping_methods: [ shippingMethod ]
          }
        }, // variable
        false, // cache
        {
          query: GQSetShippingMethodsOnCart
        }
      ).then(res => {
        if (graphqlManageError(res)) {
          // eslint-disable-next-line
          throw { errors: [{ message: graphqlManageError(res) }] }
        }
        const cart = res.data.setShippingMethodsOnCart ? res.data.setShippingMethodsOnCart.cart : null
        cart && ctx.commit('updCart', cart)
      })
    } else {
      // eslint-disable-next-line
      throw { errors: [{ message: 'cart id required' }] }
    }
  },
  placeOrder (ctx, paymentData) {
    const cartId = getCartID(ctx)
    let params = {
      method: paymentData.code
    }
    if (paymentData.additionalData) {
      params.additional_data = paymentData.additionalData
    }
    if (ctx.state.extensionAttributes) {
      params.extension_attributes = ctx.state.extensionAttributes
    }
    return HttpProvider.post(Config.API.cart[`paymentInformation${getSuffixGuest(ctx.rootGetters)}`]
      .replace('{{storeViewCode}}', ctx.rootState.ui.storeViewCode)
      .replace('{{cartId}}', cartId), {
      email: ctx.getters.email,
      paymentMethod: params
    })
      .then(res => {
        const orderId = res.data
        if (orderId.match(/^\d+$/) === null) {
          // eslint-disable-next-line
          throw { body: { result: 'orderId not valid' } }
        }
        return orderId
      })
  },
  async createAndSyncUser (ctx, { shippingAddress, billingAddress, email }) {
    await ctx.dispatch('user/create', {
      password: ctx.state.userInfo.password,
      gender: ctx.state.userInfo.gender,
      dob: ctx.state.userInfo.dob,
      privacy: {
        terms3: ctx.state.userInfo.profile
      },
      email: email,
      firstname: billingAddress.firstname,
      lastname: billingAddress.lastname
    }, { root: true })
    ctx.commit('user/newUser', true, { root: true })
    await ctx.dispatch('cart/getCartIDMask', {}, { root: true })
    await ctx.dispatch('setAddress', { address: billingAddress, type: 'Billing' })
    await ctx.dispatch('setAddress', { address: shippingAddress })
  },
  empty (ctx) {
    // reset shipping and billing address
    ctx.commit('setShippingAddress', null)
    ctx.commit('setBillingAddress', null)
    ctx.commit('setPaymentSelected', '')
    ctx.commit('setShippingMethod', null)
  },
  async init (ctx) {
    // get cartid Mask or simple, depend if logged user
    let cartId = await ctx.dispatch('cart/getCartIDMask', {}, { root: true })

    if (cartId) {
      return Graphql.genericCall(
        {},
        ctx.rootState.user.token,
        ctx.rootState.ui.storeViewCode,
        null,
        {
          cartId
        }, // variable
        false, // cache
        {
          query: GQGetCart
        }
      ).then(res => {
        if (graphqlManageError(res)) {
          // eslint-disable-next-line
          throw { errors: [{ message: graphqlManageError(res) }] }
        }
        const cart = res.data.cart ? res.data.cart : null
        cart && ctx.commit('updCart', cart)
        return cart
      })
    } else {
      // eslint-disable-next-line
      throw { errors: [{ message: 'cart id required' }] }
    }
  },
  setPickupIdOnCart (ctx, pickupId) {
    const cartId = getCartID(ctx)
    if (cartId) {
      let variables = {
        input: {
          cart_id: cartId,
          pickup_id: pickupId
        }
      }
      return Graphql.genericCall(
        {},
        ctx.rootState.user.token,
        ctx.rootState.ui.storeViewCode,
        'setPickupIdOnCart',
        variables,
        false
      )
        .then(res => {
          if (res.data) {
            if (res.data.setPickupIdOnCart && res.data.setPickupIdOnCart.cart.id) {
              return res.data.setPickupIdOnCart.cart.id
            }
          } else {
            return false
          }
        })
    } else {
      // eslint-disable-next-line
      throw { errors: [{ message: 'cart id required' }] }
    }
  }
}
